/**
 * The animated AJAX-y header quote form
 */

/* global slick */

// NOTE: The Interstate value is still being used when referring to Moving NZ to AU.
// This was done to maintain values saved in the database.  Only Labels have changed from Within NZ to NZ to AU.
// NZ to AU is treated similarly to international with a few exceptions.

(function ($, window, document, undefined) {
    'use strict';

    var pluginName = 'quoteForm',
        defaults = {},

        _formTypeString = '',

        _currentStep = 1,
        _validationStep = 1,

        _stepDataAttr = 'step-validation',
        _formTypeDataAttr = 'quote-form-type',

        _formInProgressClass = 'dark-overlay',

        _nextBtnSelector = '[data-slick="next"]',
        _prevBtnSelector = '[data-slick="prev"]',
        _datePickerSelector = '#moving_date_datepicker',
        _dateInputSelector = '#moving_date_input',

        _destinationRadioSelector = 'input[name=destination]',
        _destinationInternationalValue = 'International',
        _internationalInputClass = 'international-input',
        _showCountrySelectsClass = 'show-country-select',

        _isMoveTypeskipped = 'input[name=SkipMoveType]',

        _movingFromInputSelector = '#MovingFrom',
        _movingFromCountrySelector = '#moving_from_country',
        _movingFromAddressFieldsCountrySelector = '#MovingFromAddressFields_Country',
        _movingToInputSelector = '#MovingTo',
        _movingToCountrySelector = '#moving_to_country',
        _movingToToAddressFieldsSelector = '#MovingToAddressFields_Country',
        _movingFromCityField = '#MovingFromAddressFields_City',
        _movingToCityField = '#MovingToAddressFields_City',
        _movingToCountryField = '#MovingToAddressFields_Country',

        _businessNameInputSelector = '#full_name',
        _businessCompanyInputSelector = '#company',
        _businessPhoneInputSelector = '#phone',
        _businessEmailInputSelector = '#email',

        _pickupFromInputSelector = '#PickupFrom',
        _pickupFromCityField = '#PickupFromAddressFields_City',
        _storageLocationInputSelector = '#storage_location',
        _storageLocationNameInputSelector = '#storage_location_name',
        _storageMoveDetailsLinkSelector = '.enter-move-details-link',

        _moveSizeRadioSelector = 'input[name=size]',
        _phoneClickToCall = '.js-phone',

        _storagePickupStepSelector = '[data-step-validation="2storage"]',
        _storageMoveStepSelector = '[data-step-validation="2"]',
        _storageVolumeStepSelector = '[data-step-validation="3"]',
        _storageDateStepSelector = '[data-step-validation="4storage"]',
        _storageDetailsStepSelector = '[data-step-validation="5"]',

        _submitBtnSelect = 'button[type = "submit"]',

        _stepFormSectionTitle               = '.form-section-title',
        _stepLabel                          = '.step-label',
        _stepLabelTitle                     = '.step-label-title',

        _storageSlidesFilter                = '',

        _fieldLoadingClass                  = 'ui-autocomplete-loading',

        _$element,

        _storageAutocompleteSelected = false,

        _countriesExcludedFromValidation = [
            'MC',
            'SG',
            'HK',
            'FJ',
            'BN',
            'BH'
        ],


        _placeSearch,
        _autocompleteFrom,
        _autocompleteTo,
        _componentForm = {
            street_number: 'short_name',
            route: 'long_name',
            locality: 'long_name',
            administrative_area_level_1: 'short_name',
            country: 'long_name',
            postal_code: 'short_name'
        },

        _validation = {
            step1: [
                {
                    target: _destinationRadioSelector + ':checked',
                    showErrorOn: '.step1-options',
                    validators: {
                        isEmpty: {
                            message: 'Please select a destination'
                        }
                    }
                }
            ],
            step1B: [
                {
                    target: _movingFromInputSelector,
                    showErrorOn: _movingFromInputSelector,
                    validators: {
                        isEmpty: {
                            message: 'Please enter in your current location'
                        },
                        alphanumeric: {
                            message: 'Please use alphanumeric characters'
                        }
                    }
                },
                {
                    target: _movingFromCityField,
                    showErrorOn: _movingFromInputSelector,
                    validators: {
                        isEmpty: {
                            message: 'Please enter a city, specific address, or postal code'
                        }
                    }
                },
                {
                    target: _movingToCityField,
                    showErrorOn: _movingToInputSelector,
                    validators: {
                        isDestinationCityEmpty: {
                            message: 'Please enter a city, specific address, or postal code'
                        }
                    }
                }
            ],
            step2: [
                {
                    target: _movingFromInputSelector,
                    showErrorOn: _movingFromInputSelector,
                    validators: {
                        isEmpty: {
                            message: 'Please enter in your current location'
                        },
                        alphanumeric: {
                            message: 'Please use alphanumeric characters'
                        }
                    }
                },
                {
                    target: _movingToInputSelector,
                    showErrorOn: _movingToInputSelector,
                    validators: {
                        isEmpty: {
                            message: 'Please enter in your new location'
                        },
                        alphanumeric: {
                            message: 'Please use alphanumeric characters'
                        }
                    }
                },
                {
                    target: _movingFromCityField,
                    showErrorOn: _movingFromInputSelector,
                    validators: {
                        isEmpty: {
                            message: 'Please enter a city, specific address, or postal code'
                        }
                    }
                },
                {
                    target: _movingToCityField,
                    showErrorOn: _movingToInputSelector,
                    validators: {
                        isDestinationCityEmpty: {
                            message: 'Please enter a city, specific address, or postal code'
                        }
                    }
                }
            ],
            step3: [
                {
                    target: 'input[name=size]:checked',
                    showErrorOn: '.step3-options',
                    validators: {
                        isEmpty: {
                            message: 'Please select a size'
                        }
                    }
                }
            ],
            step4: [
                {
                    target: _dateInputSelector,
                    showErrorOn: _datePickerSelector,
                    validators: {
                        isEmpty: {
                            message: 'Please select a date'
                        }
                    }
                }
            ],
            step5: [
                {
                    target: '#full_name',
                    showErrorOn: '#full_name',
                    validators: {
                        isEmpty: {
                            message: 'Please enter your name'
                        },
                        alphanumeric: {
                            message: 'Please use alphanumeric characters'
                        }
                    }
                },
                {
                    target: '#phone',
                    showErrorOn: '#phone',
                    validators: {
                        isEmpty: {
                            message: 'Please enter your phone number'
                        },
                        alphanumeric: {
                            message: 'Please use alphanumeric characters'
                        }
                    }
                },
                {
                    target: '#email',
                    showErrorOn: '#email',
                    validators: {
                        isEmpty: {
                            message: 'Please enter your email address'
                        },
                        email: {
                            message: 'Please enter a valid email address'
                        }
                    }
                }
            ],
            step1C: [
                {
                    target: '#full_name',
                    showErrorOn: '#full_name',
                    validators: {
                        isEmpty: {
                            message: 'Please enter your name'
                        },
                        alphanumeric: {
                            message: 'Please use alphanumeric characters'
                        }
                    }
                },
                {
                    target: '#company',
                    showErrorOn: '#company',
                    validators: {
                        isEmpty: {
                            message: 'Please enter the company name'
                        },
                        alphanumeric: {
                            message: 'Please use alphanumeric characters'
                        }
                    }
                },
                {
                    target: '#phone',
                    showErrorOn: '#phone',
                    validators: {
                        isEmpty: {
                            message: 'Please enter your phone number'
                        },
                        alphanumeric: {
                            message: 'Please use alphanumeric characters'
                        }
                    }
                },
                {
                    target: '#email',
                    showErrorOn: '#email',
                    validators: {
                        isEmpty: {
                            message: 'Please enter your email address'
                        },
                        email: {
                            message: 'Please enter a valid email address'
                        }
                    }
                }
            ],
            step2C: [
                {
                    target: _movingFromInputSelector,
                    showErrorOn: _movingFromInputSelector,
                    validators: {
                        isEmpty: {
                            message: 'Please enter in your current location'
                        },
                        alphanumeric: {
                            message: 'Please use alphanumeric characters'
                        }
                    }
                },
                {
                    target: _movingToInputSelector,
                    showErrorOn: _movingToInputSelector,
                    validators: {
                        isEmpty: {
                            message: 'Please enter in your new location'
                        },
                        alphanumeric: {
                            message: 'Please use alphanumeric characters'
                        }
                    }
                },
                {
                    target: _movingFromCityField,
                    showErrorOn: _movingFromInputSelector,
                    validators: {
                        isEmpty: {
                            message: 'Please enter a city, specific address, or postal code'
                        }
                    }
                },
                {
                    target: _movingToCityField,
                    showErrorOn: _movingToInputSelector,
                    validators: {
                        isDestinationCityEmpty: {
                            message: 'Please enter a city, specific address, or postal code'
                        }
                    }
                },
                {
                    target: _dateInputSelector,
                    showErrorOn: _datePickerSelector,
                    validators: {
                        isEmpty: {
                            message: 'Please select a date'
                        }
                    }
                }
            ],
            step2storage: [
                {
                    target: _pickupFromInputSelector,
                    showErrorOn: _pickupFromInputSelector,
                    validators: {
                        isEmpty: {
                            message: 'Please enter in your pickup location'
                        },
                        alphanumeric: {
                            message: 'Please use alphanumeric characters'
                        }
                    },
                    target: _pickupFromCityField,
                    showErrorOn: _pickupFromInputSelector,
                    validators: {
                        isEmpty: {
                            message: 'Please enter a city, specific address, or postal code'
                        }
                    }
                },
                {
                    target: _storageLocationInputSelector,
                    showErrorOn: _storageLocationInputSelector,
                    validators: {
                        isEmpty: {
                            message: 'Please select your preferred storage location'
                        }
                    }
                }
            ],
            step4storage: [
                {
                    target: _dateInputSelector,
                    showErrorOn: _datePickerSelector,
                    validators: {
                        isEmpty: {
                            message: 'Please select a date'
                        }
                    }
                },
                {
                    target: '[name="storage_duration"]:checked',
                    showErrorOn: '.storage-radio-buttons-holder',
                    validators: {
                        isEmpty: {
                            message: 'Please select a duration'
                        }
                    }
                }
            ],
        },

        _errors = {};

    function Plugin (element, options) {
        var _this = this;
        _this.element = element;
        _this.settings = $.extend({}, defaults, options);
        _this.interactionStarted = false;
        _this.prefillingStorageSuggestions = false;

        _$element = $(element);

        _this.init();
    }

    $.extend(Plugin.prototype, {
        init: function () {
            var _this = this;
            _formTypeString = 'Quote Form - ' + _this._getFormType();

            var moveType = document.querySelector('#quote').dataset.quoteMoveType;
            var isInternational = moveType === _destinationInternationalValue;
            _$element.find("#MovingTo")[(isInternational ? 'add' : 'remove') + 'Class'](_internationalInputClass);

            _$element.slick({
                adaptiveHeight: true,
                arrows: false,
                draggable: false,
                infinite: false,
                swipe: false
            })
                .on('beforeChange', function (e, slick, currentSlide, nextSlide) {
                    // Tracking codes: F002, F003, L002, L003, I002, I003, In002, In003, B002, B003, C002, C003, S002, S003
                    var slideDirection = currentSlide < nextSlide ? 'forward' : 'backward';
                    GAEvents.send(_formTypeString, 'Form slide view - ' + slideDirection, 'Step ' + (currentSlide + 1) + ' to ' + (nextSlide + 1));
                })
                .on('afterChange', function (e, slick, currentSlide) {
                    _validationStep = _$element.find('.slick-current section[class^="step"]').data(_stepDataAttr);
                })
                .on('submit', function (e) {
                    e.preventDefault();
                    if (!_$element.find('.slick-current [name="quote_submit"]').length && !_$element.find('.slick-current [name="business_quote_submit"]').length) {
                        // not on last step
                        _this._nextFormStep();
                        return false;
                    } else {
                        // Tracking codes: F006, L006, I006, In006, B005, C005, S005
                        GAEvents.send(_formTypeString, 'Intent to submit', window.location.pathname);
                        var isValid = _this._validate(_validationStep);

                        if (isValid) {
                            _$element.find('.slick-current').find('.btn, input:not([type="hidden"])').addClass('disabled');
                            _$element.find('.slick-current [name="quote_submit"]').addClass('loading');
                        }

                        return isValid;
                    }
                });

            _$element.find(_nextBtnSelector).on('click', function (e) {
                _this._nextFormStep();
                return false;
            });

            _$element.find(_prevBtnSelector).on('click', function (e) {
                _this._prevFormStep();
                return false;
            });
            _$element.find(_submitBtnSelect).on('click', function (e) {

                e.preventDefault();

                if (!_validationStep) {
                    _validationStep = document.querySelector('.slick-current').dataset.stepValidation;
                }
                var isValid = _this._validate(_validationStep);

                if (!isValid)
                    return false;

                if (e.target?.type === 'submit') {
                    _this._formSubmit(e);
                }
                return false;
            });

            _$element.find(_datePickerSelector).datepicker({
                format: 'yyyy-mm-dd',
                startDate: new Date(),
                templates: {
                    leftArrow: '<span class="fa fa-chevron-circle-left"></span>',
                    rightArrow: '<span class="fa fa-chevron-circle-right"></span>'
                },
                todayHighlight: true
            }).on("changeDate", function() {
                _$element.find(_dateInputSelector).val(
                    $(this).datepicker('getFormattedDate')
                );
            });

            _$element.find(_destinationRadioSelector).on('change', function(e){
                var isInternational = $(this).val() === _destinationInternationalValue;
                _$element.find("#MovingTo")[(isInternational ? 'add' : 'remove') + 'Class'](_internationalInputClass);
                _$element.find(_movingFromInputSelector).attr('placeholder', (isInternational ? 'Current suburb / postcode' : 'Current suburb / postcode'));
                _$element.find(_movingToInputSelector).attr('placeholder', (isInternational ? 'New city' : 'New suburb / postcode'));
                _$element.find(_movingFromCountrySelector).val('New Zealand');
                _$element.find(_movingToCountrySelector).val((isInternational ? '' : 'New Zealand'));

                // Tracking code: F001
                if(!_this.interactionStarted) {
                    GAEvents.send(_formTypeString, 'Quote Started - ' + $(this).val(), window.location.pathname);
                    _this.interactionStarted = true;
                }
            });

            // $(_movingFromCountrySelector + ', ' + _movingToCountrySelector).on('change', function(e) {
            //     var $this = $(this),
            //         $thisField = $this.closest('.form-group').find('.ui-autocomplete-input');

            //     if($this.val() === 'Australia') {
            //         $thisField.autocomplete( "enable" );
            //     } else {
            //         $thisField.autocomplete( "disable" );
            //     }
            // });

            $(_storageLocationInputSelector).on('change', function(e) {
                // Tracking code: S009
                if(!_this.prefillingStorageSuggestions) {
                    GAEvents.send(_formTypeString, 'Changed suggested storage location', 'From ' + ($(_storageLocationNameInputSelector).val() || '""') + ' to ' + (this[this.selectedIndex].text || '""'));
                }
                $(_storageLocationNameInputSelector).val(this[this.selectedIndex].text);
                _this.prefillingStorageSuggestions = false;
            });

            _validationStep = _$element.find('.slick-current section[class^="step"]').data(_stepDataAttr);

            

            //
            //  Storage form specific
            // ---------------------------------------
            if (_$element.data(_formTypeDataAttr) === 'Storage') {
                // Set country selection to default to New Zealand (needed for validation)
                _$element.find(_movingFromCountrySelector).val('New Zealand');
                _$element.find(_movingToCountrySelector).val('New Zealand');

                // Filter slides so moving details aren't automatically included
                this._setStorageSteps('A');

                $(_storageMoveDetailsLinkSelector).on('click', function(e) {
                    e.preventDefault();

                    if(_this._validate(_validationStep)) {
                        _this._setStorageSteps('B');
                        _this._nextFormStep();
                    }
                });

                _$element.on('afterChange', function(event, slick, currentSlide) {
                    if(currentSlide === 1) {
                        _this._setStorageSteps('A');
                    }
                });

                // Tracking code: S001
                _$element.find('.step1 [data-slick="next"]').on('click.track', function(e) {
                    if(!_this.interactionStarted) {
                        GAEvents.send(_formTypeString, 'Quote Started', window.location.pathname);
                        _this.interactionStarted = true;
                        $(this).off('click.track');
                    }
                });

                // Tracking code: S008
                _$element.find('[name="storage_duration"]').on('change', function(e) {
                    GAEvents.send(_formTypeString, 'Changed storage duration', $(this).val());
                });
            }

            // Tracking code: F004, L004, I004, In004
            _$element.find(_moveSizeRadioSelector).on('change', function(e){
                GAEvents.send(_formTypeString, 'Move size select', $(this).val());
            });

            // Tracking code: F005, L005, I005, In005, B004, C004, S004
            _$element.on('click', _phoneClickToCall, function(e) {
                var $currentSlide = _$element.find('.slick-current');
                var stepLabel = $currentSlide.find('.step-label').text();
                var stepLabelTitle = $currentSlide.find('.step-label-title').text();

                if(_$element.data(_formTypeDataAttr) === 'Business' && Number($currentSlide.data('slick-index')) === 0) {
                    stepLabel =  'Step 1';
                    stepLabelTitle = $currentSlide.find('.step-label').text();
                } else if(_$element.data(_formTypeDataAttr) === 'Storage' && Number($currentSlide.data('slick-index')) === 0) {
                    stepLabel =  'Step 0';
                    stepLabelTitle = 'Get started';
                } else {
                    stepLabel = $currentSlide.find('.step-label').text();
                    stepLabelTitle = $currentSlide.find('.step-label-title').text();
                }

                GAEvents.send(_formTypeString, 'Click to call', stepLabel + ' - ' + stepLabelTitle);
            });

            // Initial quote interaction tracking
            var trackInitialInteraction = function (selectors) {
                _$element.find(selectors).on('keyup.track, change.track', function(e) {
                    if(!_this.interactionStarted) {
                        GAEvents.send(_formTypeString, 'Quote Started', window.location.pathname);
                        _this.interactionStarted = true;
                        _$element.find(selectors).off('keyup.track, change.track');
                    }
                });
            };

            if (_$element.data(_formTypeDataAttr) !== 'Storage' && _$element.data(_formTypeDataAttr) !== 'Business' && _$element.data(_formTypeDataAttr) !== 'Beginning') {
                // Tracking code: L001, I001, In001
                trackInitialInteraction([_movingFromInputSelector, _movingToInputSelector].join(','));
            } else if(_$element.data(_formTypeDataAttr) === 'Business') {
                // Tracking code: B001, C001
               trackInitialInteraction([_businessNameInputSelector, _businessCompanyInputSelector, _businessPhoneInputSelector, _businessEmailInputSelector].join(','));
            }
        },

        // Public functions
        initAutoComplete: function() {
            var _this = this;

            if(_$element.find('.slick-current').data(_stepDataAttr) === '1B' || _$element.find('.slick-current').data(_stepDataAttr) === '1storage') {
                _this._setUpAutocomplete();
            } else {
                // User hasn't chosen local/interstate/international yet
                _$element.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
                    if(nextSlide === 0) {
                        _this._destroyAutocomplete();
                    } else if(currentSlide === 0 && nextSlide === 1) {
                        _this._setUpAutocomplete();
                    }
                });
            }
        },

        // Private functions
        _destroyAutocomplete: function() {
            $(_movingFromInputSelector + ', ' + _movingToInputSelector + ', ' + _pickupFromInputSelector).autocomplete("destroy");
        },

        _setUpAutocomplete: function() {
            this._setAutocompleteLocalInterstate();

            if(_$element.hasClass(_showCountrySelectsClass)) {
                $(_movingToInputSelector).autocomplete( "disable" );
            }
        },

        _setAutocompleteLocalInterstate: function() {
            var _this = this;

            $(_movingFromInputSelector + ', ' + _movingToInputSelector + ', ' + _pickupFromInputSelector)
                .autocomplete({
                    minLength:3, //minimum length of characters for type ahead to begin
                    source: function (request, response) {
                        $.ajax({
                            type: 'POST',
                            url: "/SfApi/NzPostAddress/GetNzAddressSuggestions",
                            headers: { 'X-API-Key': 'IbxeqEcmkQ52cE4burH3kqczlSCY9Wvr' },
                            contentType: "application/json; charset=utf-8",
                            data: JSON.stringify({
                                "value": request.term
                            }),

                            success: function (data) {
                                //if multiple results are returned
                                try {
                                    if(data.length) {
                                        response($.map(data, function (item) {
                                            return {
                                                label: item.location + ', ' + item.post_code + ', ' + item.region_code,
                                                state: item.region_code,
                                                postcode: item.post_code,
                                                suburb: item.location,
                                                country: 'New Zealand'
                                            }
                                        }));
                                    } else {
                                        response({});
                                    }
                                } catch(e) {
                                    response({});
                                }
                            },
                            error: function (data) {
                                response({});
                            }
                        });
                    }
                })
                .on( "autocompleteselect", function( event, ui ) {
                    var isPickupField = '#' + $(this).attr('id') === _pickupFromInputSelector;
                    _this._fillAddressAusPost(
                        ('#' + $(this).attr('id') === _movingToInputSelector ? 'to' : 'from'),
                        {suburb: ui.item.suburb, postcode: ui.item.postcode, state: ui.item.state, country: ui.item.country}, (isPickupField ? 'pickup' : 'address'));

                    if (isPickupField) {
                        _storageAutocompleteSelected = true;
                        _this._queryStorageLocations(ui.item.postcode, ui.item.suburb);
                    }

                    // Tracking codes: F008, L008, I008, In008, B007, C007, S007
                    var fieldName = isPickupField ?
                        'Pickup from' :
                        ('#' + $(this).attr('id') === _movingToInputSelector) ?
                            'Moving to' :
                            'Moving from';
                    GAEvents.send(_formTypeString, 'Used suggested location', fieldName);
                })
                .on( "focusout", function(e) {
                    var isPickupField = '#' + $(this).attr('id') === _pickupFromInputSelector;
                    if (isPickupField && !_storageAutocompleteSelected) {
                        var inputVal = $(_pickupFromInputSelector).val();
                        if (inputVal === '')
                            return;

                        if (isNaN((Number(inputVal) + 1))) {
                            _this._queryStorageLocations('', inputVal);
                        } else {
                            _this._queryStorageLocations(inputVal, '');
                        }
                    }
                    _storageAutocompleteSelected = false;
                });
        },

        _fillAddressGoogle: function(toFrom, placesData) {
            var numComponents = placesData.address_components.length,
                componentForm = {
                    street_number: 'long_name',
                    route: 'long_name',
                    locality: 'long_name',
                    administrative_area_level_1: 'long_name',
                    country: 'long_name',
                    postal_code: 'long_name'
                },
                fieldMap = {
                    street_number: '#' + toFrom + '_address_number',
                    route: '#' + toFrom + '_address_street',
                    locality: '#' + toFrom + '_address_suburb',
                    administrative_area_level_1: '#' + toFrom + '_address_state',
                    country: '#' + toFrom + '_address_country',
                    postal_code: '#' + toFrom + '_address_postcode'
                },
                field;

            for(field in fieldMap) {
                $(fieldMap[field]).val('');
            }

            for (var i = 0; i < numComponents; i++) {
                var addressType = placesData.address_components[i].types[0];
                if (componentForm[addressType]) {
                    var val = placesData.address_components[i][componentForm[addressType]];
                    $(fieldMap[addressType]).val(val);
                }
            }
        },

        _fillAddressAusPost: function(toFrom, data, prefix) {
            var fieldMap = {
                    suburb: '#' + toFrom + '_' + prefix + '_suburb',
                    state: '#' + toFrom + '_' + prefix + '_state',
                    postcode: '#' + toFrom + '_' + prefix + '_postcode',
                    country: '#' + toFrom + '_' + prefix + '_country'
                },
                field;

            for(field in fieldMap) {
                $(fieldMap[field]).val('');
            }

            for(field in fieldMap) {
                $(fieldMap[field]).val(data[field]);
            }
        },

        _setStorageSteps: function(version) {
            if (version === 'A' && _storageSlidesFilter !== 'A') {
                // Clear moving fields
                $(_movingFromInputSelector).val('');
                $(_movingToInputSelector).val('');
                $('[id^="from_address_"]').val('');
                $('[id^="to_address_"]').val('');

                // Filter slides
                _$element.slick('slickFilter', '[data-storage-filter-A]').slick('refresh');

                // Make sure step labels are correct
                $(_storageVolumeStepSelector + ' ' + _stepLabel).text('Step 2');
                $(_storageVolumeStepSelector + ' ' + _stepLabelTitle).text('What volume of storage do you need?');
                $(_storageDateStepSelector + ' ' + _stepLabel).text('Step 3');
                $(_storageDetailsStepSelector + ' ' + _stepLabel).text('Step 4');
            } else if (version === 'B' && _storageSlidesFilter !== 'B') {
                // Unfilter slides
                _$element.slick('slickUnfilter');

                // Fill moving fields
                $(_movingFromInputSelector).val($(_pickupFromInputSelector).val()).prop('readonly', true);
                $(_movingToInputSelector).val('');
                $('[id^="from_address_"]').each(function() {
                    var thisIdArr = $(this).attr('id').split('_');
                    $(this).val($('#' + thisIdArr[0] + '_pickup_' + thisIdArr[2]).val());
                });
                $('[id^="to_address_"]').val('');

                // Make sure move step label is correct
                $(_storageMoveStepSelector + ' ' + _stepLabel).text('Step 2');
                $(_storageVolumeStepSelector + ' ' + _stepLabel).text('Step 3');
                $(_storageDateStepSelector + ' ' + _stepLabel).text('Step 4');
                $(_storageDetailsStepSelector + ' ' + _stepLabel).text('Step 5');
            }

            _storageSlidesFilter = version;
        },

        _nextFormStep: function () {
            if (!_validationStep) {
                _validationStep = document.querySelector('.slick-current').dataset.stepValidation;
            }
            if(this._validate(_validationStep)) {
                _$element.slick('slickNext');
                _currentStep++;

                if(_currentStep > 1) {
                    _$element.addClass(_formInProgressClass);
                }
            }
        },

        _prevFormStep: function() {
            _$element.slick('slickPrev');
            _currentStep--;

            var isMoveTypeSkipped = $(_isMoveTypeskipped).val();

            if (_currentStep < 2 && !isMoveTypeSkipped) {
                _$element.removeClass(_formInProgressClass);
            }
        },

        _validate: function(stepNum) {
            var key = 'step' + stepNum;

            if(!_validation[key])
                return true;

            var def,
                $el,
                a = 0,
                numToValidate = _validation[key].length,
                validator,
                isValid = true;

            this._removeErrors(stepNum);

            var moveType = document.querySelector('#quote').dataset.quoteMoveType;

            for(a=0; a<numToValidate; a++) {
                def = _validation[key][a];
                $el = _$element.find('.step' + stepNum + ' ' + def.target);

                for (validator in def.validators) {
                    if (moveType != null && moveType !== 'International' && def.target === _movingToCountrySelector) {
                        continue;
                    }
                    if(!this['_validate_' + validator]($el.val())) {
                        this._renderError(stepNum, def.validators[validator].message, def.showErrorOn);
                        isValid = false;
                    }
                }
            }

            return isValid;
        },
        _formSubmit: function (e) {
            grecaptcha.ready(function () {
                grecaptcha.execute('6LdnrJQjAAAAAJkp1BMX2C8oPC11ZRsBvbpjnfF9', { action: 'submit' }).then(function (token) {

                    //Set Token to hidden field.
                    $("#g-reCaptcha-token").val(token);
                   // if (!isSubmitNzValid) {
                   //     return false;
                   // }
                    //Submit
                    //$("button:submit.btn-submit-hdn").click();
                    document.getElementById("quote").submit();
                });
            });
        },
        _validate_isEmpty: function(value) {
            return value != '' && value != undefined && value != null;
        },

        _validate_email: function (value) {
            return /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/i.test(value);
        },

        _validate_alphanumeric: function (value) {
            // return /^[ a-zA-Z0-9,.]*$/i.test(value);
            return true;
        },

        _validate_isDestinationCityEmpty: function (value) {
            var countryCode = _$element.find(_movingToCountryField).val();
            if (countryCode != null && _countriesExcludedFromValidation.includes(countryCode.toUpperCase())) {
                return true;
            }
            return value != '' && value != undefined && value != null;
        },

        _renderError: function(stepNum, errMsg, errorOn) {
            var key = 'step' + stepNum,
                $el = _$element.find(errorOn),
                err = $('<p class="form-error text-center error-alert">' + errMsg + '</p>');

            if(!_errors[key])
                _errors[key] = [];

            $el.after(err);
            _errors[key].push(err);

            $el.removeClass('error-alert');
            $el.height();
            $el.addClass('error-alert');

            if($el.is('.form-control')) {
                $el.closest('.form-group').addClass('has-error');
            }
        },

        _removeErrors: function(stepNum) {
            var key = 'step' + stepNum;
            if(_errors[key]) {
                var a,
                    def,
                    $el,
                    numErrs = _errors[key].length,
                    numTargets = _validation[key].length;

                for(a=0; a<numErrs; a++) {
                    _errors[key][a].remove();
                }
                delete _errors[key];

                for(a=0; a<numTargets; a++) {
                    def = _validation[key][a];
                    $el = _$element.find('.step' + stepNum + ' ' + def.target);

                    if ($el.is('.form-control')) {
                        $el.closest('.form-group').removeClass('has-error');
                    }
                }
            }
        },

        _queryStorageLocations: function(postcode, city) {
            var _this = this;

            $(_storageLocationInputSelector).addClass(_fieldLoadingClass);

            $.ajax({
                type: 'POST',
                url:'/SfApi/NzPostAddress/GetStorageBranch',
                headers: { 'X-API-Key': 'IbxeqEcmkQ52cE4burH3kqczlSCY9Wvr' },
                contentType: "application/json; charset=utf-8",
                data: JSON.stringify({
                    postcode: postcode,
                    city: city                    
                }),                
                success: function (data) {
                    _this._prefillStorage(data);
                },
                error: function (data) {
                    alert(data.responseText);
                }
            });
        },

        _prefillStorage: function(data) {
            this.prefillingStorageSuggestions = true;
            var $suggested = $('optgroup[data-suggested]');
            var $storageLocationSelect = $(_storageLocationInputSelector).removeClass(_fieldLoadingClass);

            if ($suggested.length) {
                $suggested.remove();
            }

            var suggestionsHTML = '';
            if (data.branches.length > 0) {
                suggestionsHTML += '<optgroup label="Suggested location' + (data.branches.length > 1 ? 's' : '') + '" data-suggested>';
                var suggestion;

                for (suggestion in data.branches) {
                    suggestionsHTML += '<option value="' + data.branches[suggestion].branch_code + '" data-suggested>' + data.branches[suggestion].branch_location + '</option>';
                }

                suggestionsHTML += '</optgroup>';

                $suggested = $(suggestionsHTML);
                $storageLocationSelect.find('option[value=""]').after($suggested);

                if (data.branches.length === 1) {
                    $storageLocationSelect.val(data.branches[0].branch_code).trigger('change');
                } else {
                    $storageLocationSelect.val('').trigger('change');
                }
            } else {
                $storageLocationSelect.val('').trigger('change');
            }
        },

        _getFormType: function() {
            var toReturn = '';

            switch(_$element.data(_formTypeDataAttr)) {
                case 'Business':
                    toReturn = window.location.pathname.indexOf('/corporate') > -1 ? 'Corporate Relocation' : 'Business Relocation';
                    break;

                case 'Beginning':
                    toReturn = 'Full';
                    break;

                case 'Interstate':
                    toReturn = 'To Australia';
                    break;

                default:
                    toReturn = _$element.data(_formTypeDataAttr);
                    break;
            }

            return toReturn;
        }
    });

    $.fn[pluginName] = function (options) {
        var args = arguments;

        if (options === undefined || typeof options === 'object') {

            return this.each(function () {
                if (!$.data(this, 'plugin_' + pluginName)) {
                    $.data(this, 'plugin_' + pluginName, new Plugin(this, options));
                }
            });

        } else if (typeof options === 'string' && options[0] !== '_' && options !== 'init') {

            var returns;
            this.each(function () {
                var instance = $.data(this, 'plugin_' + pluginName);
                if (instance instanceof Plugin && typeof instance[options] === 'function') {
                    returns = instance[options].apply(instance, Array.prototype.slice.call(args, 1));
                }

                if (options === 'destroy') {
                    $.data(this, 'plugin_' + pluginName, null);
                }
            });

            return returns !== undefined ? returns : this;
        }
    };

}(jQuery, window, document));
